import { connect } from 'react-redux';
import partial from 'lodash/partial';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import ConfirmDialog from 'common/components/modal/confirmation_dialog';
import { toggleCloseModal, closeProject } from 'project/ducks/features';
import { getProjectIdFromUrl } from 'project/utils';

const mapStateToProps = ({ project }) => {
  const { showingCloseModal } = project.features;
  const msg = `
    If you're ready to move to the wrap-up stage in this project and review final files,
    click "Yes, I'm Ready" below. Once you click the button below, you'll see the project
    gallery. Hover your mouse over the entry you want to award and a pink AWARD button will
    appear. Click the AWARD button and we'll move the project to wrap-up. It's that easy!
  `;

  return {
    dialogVisible: showingCloseModal,
    dialogHeader: "Please confirm",
    dialogMessage: msg,
    primaryActionText: "Yes, I'm Ready"
  };
}

const mapDispatchToProps = (dispatch, { params }) => {
  const projectId = getProjectIdFromUrl(params);
  const { subcategory, pageSlug } = params;
  const next = `/${subcategory}/${pageSlug}/entries/`;

  return bindActionCreators({
    toggleDialog: toggleCloseModal,
    submitAction: partial(closeProject, projectId, next)
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog));



// WEBPACK FOOTER //
// ./project/containers/close_modal.js